import { T_Profile } from '../types';

export let getCustomerId = (profile: T_Profile) => '-' + profile.profileId.replace(/[^0-9]/g, '').substring(0, 9);
